import orgContainer from '@Components/AppContainer';
import InnerComponent from '@Components/HelpDesk';

const HelpDesk = () => ((orgContainer(InnerComponent)));

export default HelpDesk;
